import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";

export const EnablePostPurchaseToggle = () => (
  <Form.Item
    className="!mt-0 !py-0"
    name="thank_you_page_enabled"
    translationRoot="settings.paywalls.modal.tabs.post_purchase"
    inline
    tooltipText={t(
      "settings.paywalls.modal.tabs.post_purchase.thank_you_page_enabled_tooltip",
    )}
    hideDescription
    hideBorder
    labelClassName="text-xl tightest font-semibold"
  >
    <Form.ToggleSwitch name="thank_you_page_enabled" variant="large" />
  </Form.Item>
);
